var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61255 14.0732C3.52142 14.073 3.43132 14.0536 3.34799 14.0162C3.26465 13.9788 3.1899 13.9242 3.12848 13.8559C3.06595 13.7881 3.01823 13.7077 2.98846 13.6199C2.95869 13.5322 2.94754 13.439 2.95574 13.3465L3.11665 11.5505L10.5504 4.00786L12.8736 6.36519L5.44176 13.9072L3.67232 14.0705C3.65245 14.0724 3.6325 14.0733 3.61255 14.0732ZM13.3373 5.89386L11.0148 3.53653L12.4079 2.12253C12.4689 2.06054 12.5413 2.01137 12.6211 1.97782C12.7008 1.94427 12.7863 1.927 12.8726 1.927C12.9589 1.927 13.0444 1.94427 13.1241 1.97782C13.2038 2.01137 13.2763 2.06054 13.3373 2.12253L14.7304 3.53653C14.7914 3.59844 14.8399 3.67197 14.8729 3.7529C14.906 3.83383 14.923 3.92058 14.923 4.00819C14.923 4.0958 14.906 4.18255 14.8729 4.26349C14.8399 4.34442 14.7914 4.41794 14.7304 4.47986L13.3373 5.89386Z",
    fill: "#8F4300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.7dac300cdd9ed999cd62f206123bcbf8.svg";
export { ForwardRef as ReactComponent };